import React, { useEffect, useState, useRef } from "react";
import Header from '../component/Header';
import Footer from '../component/Footer';
import "./pages.css";
import axios from "../helper/axios";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import AccordionSummary from "@material-ui/core/AccordionSummary";


export default function Faqs() {

  const [allProduct, setAllProduct] = useState([]);

  const apiData = async () => {
    const res = await axios.post("/FaqGet");
    console.log(res?.status);
    if (res.status === 200) {
      setAllProduct(res?.data[0]);
    } else {
      setAllProduct()
    }
  }

  useEffect(() => {
    apiData();
  }, []);

  const faqList = allProduct.faqlist;

  const ref = useRef(null);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0 });
  };
  useEffect(() => {
    scrollToTop();
  }, [])

  return (
    <>
      <Header />
      <div className='container mx-auto pt-28'>
        <div className="Cart mt-heading">
          <div className="p-0-mobile container wishlist">
            <div className="">
              <div className="CartItem fade-in-down">
                <div className="CartItem__content inner-pages">
                  {faqList?.map((dt, index) => (
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                      >
                        <Typography
                          style={{
                            fontWeight: 10,
                          }}
                        >
                          <h3>{dt.title}</h3>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>{dt.description}</Typography>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
